import React, { useEffect } from "react";
import { CRMSpacing } from "../../../models/CRMSpacing";
import { CRMPopoutHeader } from "../../Simple/CRMPopoutHeader/CRMPopoutHeader";
import { SpacingColumn } from "../../BuildingBlocks/SpacingColumn";
import { CRMBottomControlBar } from "../../CRMBottomControlBar/CRMBottomControlBar";
import { Background } from "../../BuildingBlocks/Background";
import { SpacingRow } from "../../BuildingBlocks/SpacingRow";
import { CRMFormButton } from "../../CRMFormButton/CRMFormButton";
import { CRMButtonPrimary } from "../../CRMButtonPrimary/CRMButtonPrimary";
import { TContainerStateProps } from "../../../state/TContainerStateProps";
import { CRMCardOutsidePopupBlank } from "../../CRMCardOutsidePopupBlank/CRMCardOutsidePopupBlank";
import { CRMParagraph } from "../../Simple/CRMParagraph/CRMParagraph";
import { WeightSemiBold } from "../../WeightSemiBold/WeightSemiBold";
import { CRMParagraphBulletPoints } from "../../CRMBulletList/CRMParagraphBulletPoints";
import { ChaseReasons_displayString } from "../../../../../domain/codecs/Cases";
import { CRMButtonSecondary } from "../../CRMButtonSecondary/CRMButtonSecondary";


export const CRMCloseChaseContinueCasePopoutChaserView = (
    props: TContainerStateProps & {
        isOpen: boolean,
        onClose: () => void,
    }): JSX.Element => {
    
    const reasons = props.state.forms.chase_mode_form.children.current_chase_reasons;
    const getAcceptChaseForm = () => props.state.forms.chase_mode_form.children.accept_chase_transition_form;
    const getRejectChaseForm = () => props.state.forms.chase_mode_form.children.reject_from_chase_mode_form;
    const isSubmitting = getAcceptChaseForm().status === "submitting" || getRejectChaseForm().status === "submitting";

    useEffect(
        () => {
            if (getAcceptChaseForm().status === "success") {
                props.onClose();
            }
        },
        [getAcceptChaseForm().status],
    );

    useEffect(
        () => {
            if (getRejectChaseForm().status === "success") {
                props.onClose();
            }
        },
        [getRejectChaseForm().status],
    );

    return (
        <CRMCardOutsidePopupBlank
            isOpen={props.isOpen}
            context="none"
            size="regular"
            borderRadius="5px"
            cardMargin="78px 0px"
            onClose={props.onClose}
        >
            {/* HEADER */}
            <CRMPopoutHeader
                icon="arrow-left"
                borderRadius="5px"
                onClick={props.onClose}
            >
                Approve/Reject Chase Request
            </CRMPopoutHeader>
            
            <Background padding={`${CRMSpacing.LARGE} ${CRMSpacing.LARGE} ${CRMSpacing.LARGE} ${CRMSpacing.LARGE}`} minHeight="100px">
                <SpacingColumn spacing={CRMSpacing.SMALL}>
                    <CRMParagraph>
                        <SpacingColumn spacing={CRMSpacing.SMALL}>
                            <WeightSemiBold>Reasons:</WeightSemiBold>
                            <CRMParagraphBulletPoints
                                bullets={reasons.map((reason) => ChaseReasons_displayString(reason))}
                            />
                        </SpacingColumn>
                    </CRMParagraph>
                </SpacingColumn>
            </Background>


            {/* ACCEPT/REJECT BUTTONS*/} 
            <div style={{overflow: "clip", borderRadius: "5px"}}>
                <CRMBottomControlBar
                    justifyContent="flex-end"
                    edge="border"
                >
                    <SpacingColumn>
                        <Background padding={CRMSpacing.MEDIUM}>
                            <SpacingRow spacing={CRMSpacing.MEDIUM} justifyContent="end">
                                {/* REJECT */}
                                <CRMFormButton
                                    ButtonElement={CRMButtonSecondary}
                                    formStatus={getRejectChaseForm().status}
                                    label="Reject"
                                    disabled={isSubmitting}
                                    onClick={() => props.dispatch({
                                        type: "LEGAL_CASE_REJECT_FROM_CHASE_MODE_FORM_SUBMIT",
                                        payload: undefined,
                                    })}
                                />

                                {/* ACCEPT */}
                                <CRMFormButton
                                    ButtonElement={CRMButtonPrimary}
                                    formStatus={getAcceptChaseForm().status}
                                    label="Accept"
                                    disabled={isSubmitting}
                                    onClick={() => props.dispatch({
                                        type: "LEGAL_CASE_ACCEPT_TO_CHASE_MODE_FORM_SUBMIT",
                                        payload: undefined,
                                    })}
                                />
                            </SpacingRow>
                        </Background>
                    </SpacingColumn>
                </CRMBottomControlBar>
            </div>
        </CRMCardOutsidePopupBlank>
    );
};
